// Indian currency + date helpers

export function formatINR(n) {
  if (n === null || n === undefined || n === "") return "\u2014";
  const num = Number(n);
  if (Number.isNaN(num)) return "\u2014";
  return "\u20b9" + num.toLocaleString("en-IN");
}

export function formatINRShort(n) {
  if (n === null || n === undefined || n === "") return "\u2014";
  const num = Number(n);
  if (Number.isNaN(num)) return "\u2014";
  if (num >= 10000000) return "\u20b9" + (num / 10000000).toFixed(2).replace(/\.00$/, "") + " Cr";
  if (num >= 100000) return "\u20b9" + (num / 100000).toFixed(2).replace(/\.00$/, "") + " L";
  if (num >= 1000) return "\u20b9" + (num / 1000).toFixed(1).replace(/\.0$/, "") + "K";
  return "\u20b9" + num.toLocaleString("en-IN");
}

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export function formatDate(iso) {
  if (!iso) return "\u2014";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "\u2014";
  return `${d.getDate()} ${MONTHS[d.getMonth()]} ${d.getFullYear()}`;
}

export function formatDateShort(iso) {
  if (!iso) return "\u2014";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "\u2014";
  return `${d.getDate()} ${MONTHS[d.getMonth()]}`;
}

export function formatDateTime(iso) {
  if (!iso) return "\u2014";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "\u2014";
  let h = d.getHours();
  const m = String(d.getMinutes()).padStart(2, "0");
  const ap = h >= 12 ? "PM" : "AM";
  h = h % 12 || 12;
  return `${d.getDate()} ${MONTHS[d.getMonth()]}, ${h}:${m} ${ap}`;
}

export function timeAgo(iso) {
  if (!iso) return "";
  const d = new Date(iso).getTime();
  const diff = Date.now() - d;
  const min = Math.floor(diff / 60000);
  if (min < 1) return "just now";
  if (min < 60) return `${min}m ago`;
  const hr = Math.floor(min / 60);
  if (hr < 24) return `${hr}h ago`;
  const day = Math.floor(hr / 24);
  if (day < 30) return `${day}d ago`;
  return formatDateShort(iso);
}

export function todayISO() {
  return new Date().toISOString().slice(0, 10);
}

export function monthLabel(monthStr) {
  // monthStr = 'YYYY-MM'
  if (!monthStr) return "";
  const [y, m] = monthStr.split("-");
  return `${MONTHS[parseInt(m, 10) - 1]} ${y}`;
}
